
import React, { PureComponent } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputCheckBox from '../../commons/form/InputCheckBox'

import { typeFields as metadataType } from '../../../constants/dossier/common/typeFields'
import { getComboTranslatedFromEnum, compareObjects, handleKeyDown } from '../../../util/utils'
import { getObjectWithLocales } from '../../../util/masters/masters'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'

class MetadataMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      isSelectedMetadataTypeSelect: false,
      initialDocumentTypeMetadata: {},
      functionToGetRealValue: null,
      functionToSetRealValue: null,
      fieldEntityName: null
    }
  }

  handleMetadataTypeChange (metadataTypeId) {
    const isListType = metadataTypeId === metadataType.list
    this.setState({ isSelectedMetadataTypeSelect: isListType })
    if (!isListType) {
      this.props.change('getListValues', null)
    }
  }

  submitDocument (values) {
    let languages = []
    Object.keys(values).map(item => {
      if (!!values[item] && typeof values[item] === 'object' && Object.keys(values[item]).length > 0) {
        languages.push(values[item])
      }
    })

    let basicDocumentTypeMetadata = {
      metadatoId: values.metadatoId,
      documentTypeId: this.props.documentTypeId,
      code: values.code,
      metadatoType: values.metadatoType,
      isMandatory: values.isMandatory,
      isReadOnly: values.isReadOnly,
      getListValues: values.getListValues,
      fieldEntityName: values.fieldEntityName,
      functionToGetRealValue: values.functionToGetRealValue,
      functionToSetRealValue: values.functionToSetRealValue,
      customValidations: values.customValidations,
      solpheoMetadataKey: values.solpheoMetadataKey,
      functionToExecuteInFront: values.functionToExecuteInFront
    }

    let docTypeCopy = Object.assign({}, { ...basicDocumentTypeMetadata, ...this.state.initialDocumentTypeMetadata })
    let initialDocumentTypeMetadataCopy = Object.assign({}, { ...this.state.initialDocumentTypeMetadata, ...basicDocumentTypeMetadata })
    const isEditedCriticalProperty = !compareObjects(docTypeCopy, initialDocumentTypeMetadataCopy, true)
    const documentTypeMetadata = { ...basicDocumentTypeMetadata, metadatoLocales: languages }
    this.props.actions.submitDocumentTypeMetadata(documentTypeMetadata, isEditedCriticalProperty)
  }

  initializeModal () {
    const documentTypeMetadata = this.props.documentTypeMetadata
    const documentTypeMetadataWithLocales = getObjectWithLocales(documentTypeMetadata, documentTypeMetadata?.metadatoLocales ?? [], this.props.languageList)
    const isListType = documentTypeMetadataWithLocales.metadatoType === metadataType.list
    if (!isListType) {
      documentTypeMetadataWithLocales.getListValues = null
    }
    if (documentTypeMetadataWithLocales.metadatoType === 0) {
      documentTypeMetadataWithLocales.metadatoType = null
    }

    this.setState({
      isSelectedMetadataTypeSelect: isListType,
      initialDocumentTypeMetadata: documentTypeMetadata || {},
      functionToGetRealValue: null,
      functionToSetRealValue: null,
      fieldEntityName: null
    })

    this.props.initialize({ ...documentTypeMetadataWithLocales })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.initializeModal()
    }
  }

  disableFieldEntityName () {
    return this.state.functionToSetRealValue?.trim().length > 0 || this.state.functionToGetRealValue?.trim().length > 0 || false
  }

  disableRealValueFunctionsFields () {
    return this.state.fieldEntityName?.trim().length > 0 || false
  }

  handleFieldEntityNameChange (value) {
    this.setState({
      fieldEntityName: value
    })
  }

  handleFunctionToGetRealValueChange (value) {
    this.setState({
      functionToGetRealValue: value
    })
  }

  handleFunctionToSetRealValueChange (value) {
    this.setState({
      functionToSetRealValue: value
    })
  }

  render () {
    const {
      t, handleSubmit,
      showModal, languageList, documentTypeMetadata
    } = this.props
    const tKey = 'MASTERS.METADATA_MASTERS.MODAL.'
    let metadatoTypes = getComboTranslatedFromEnum(t, tKey, metadataType)
    return (
      <Modal id="metadataMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeMetadataMasterModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeMetadataMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form auto">
              {documentTypeMetadata?.documentTypeMetadataId &&
                <Field
                  component={InputText}
                  colWidth={0} // 25, 33, 50, 75, 100 default=25
                  name="metadatoId"
                  controlLabel={t(`${tKey}ID`)}
                  placeholder={t(`${tKey}ID`)}
                  disabled={true}
                />
              }
              <Field
                component={InputText}
                colWidth={0} // 25, 33, 50, 75, 100 default=25
                name="code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
              />
            </div>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="metadatoType"
                controlLabel={t(`${tKey}METADATO_TYPE`)}
                placeholder={t(`${tKey}METADATO_TYPE`)}
                options={metadatoTypes}
                valueKey="id"
                labelKey="value"
                onChange={(val) => this.handleMetadataTypeChange(val)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="isMandatory"
                controlLabel={t(`${tKey}IS_MANDATORY`)}
                placeholder={t(`${tKey}IS_MANDATORY`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="isReadOnly"
                controlLabel={t(`${tKey}IS_READONLY`)}
                placeholder={t(`${tKey}IS_READONLY`)}
              />
              {this.state.isSelectedMetadataTypeSelect &&
                  <Field
                    component={InputText}
                    colWidth={33} // 25, 33, 50, 75, 100 default=25
                    name="getListValues"
                    controlLabel={t(`${tKey}GET_LIST_VALUES`)}
                    placeholder={t(`${tKey}GET_LIST_VALUES`)}
                  />
              }

              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="fieldEntityName"
                controlLabel={t(`${tKey}FIELD_ENTITY_NAME`)}
                placeholder={t(`${tKey}FIELD_ENTITY_NAME`)}
                disabled = {this.disableFieldEntityName()}
                onInputChange = { (value) => this.handleFieldEntityNameChange(value)}
                maxLength = {50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="functionToGetRealValue"
                controlLabel={t(`${tKey}FUNCTION_TO_GET_REAL_VALUE`)}
                placeholder={t(`${tKey}FUNCTION_TO_GET_REAL_VALUE`)}
                onInputChange = { (value) => this.handleFunctionToGetRealValueChange(value)}
                disabled = {this.disableRealValueFunctionsFields()}
                maxLength = {50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="functionToSetRealValue"
                controlLabel={t(`${tKey}FUCNTION_TO_SET_REAL_VALUE`)}
                placeholder={t(`${tKey}FUCNTION_TO_SET_REAL_VALUE`)}
                onInputChange = { (value) => this.handleFunctionToSetRealValueChange(value)}
                disabled = {this.disableRealValueFunctionsFields()}
                maxLength = {50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="customValidations"
                controlLabel={t(`${tKey}CUSTOM_VALIDATIONS`)}
                placeholder={t(`${tKey}CUSTOM_VALIDATIONS`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="solpheoMetadataKey"
                controlLabel={t(`${tKey}SOLPHEO_METADATA_KEY`)}
                placeholder={t(`${tKey}SOLPHEO_METADATA_KEY`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="functionToExecuteInFront"
                controlLabel={t(`${tKey}FUNCTION_TO_EXECUTE_FRONT`)}
                placeholder={t(`${tKey}FUNCTION_TO_EXECUTE_FRONT`)}
              />
            </div>
            <br/>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editDocumentTypeMetadata',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.METADATA_MASTERS.VALIDATION.'
    if (!values.code || values.code.length > 50) {
      error.code = props.t(`${tKey}CODE`)
    }
    if (!values.metadatoType || values.metadatoType <= 0) {
      error.metadatoType = props.t(`${tKey}METADATO_TYPE`)
    }
    if (!values.fieldEntityName && !values.functionToGetRealValue && !values.functionToSetRealValue) {
      error.fieldEntityName = props.t(`${tKey}FIELD_ENTITY_NAME`)
      error.functionToGetRealValue = props.t(`${tKey}FUNCTION_TO_GET_REAL_VALUE`)
      error.functionToSetRealValue = props.t(`${tKey}FUNCTION_TO_SET_REAL_VALUE`)
    }

    if (!values.fieldEntityName && (!values.functionToGetRealValue && !!values.functionToSetRealValue)) {
      error.functionToGetRealValue = props.t(`${tKey}FUNCTION_TO_GET_REAL_VALUE`)
    }
    if (!values.fieldEntityName && (!values.functionToSetRealValue && !!values.functionToGetRealValue)) {
      error.functionToSetRealValue = props.t(`${tKey}FUNCTION_TO_SET_REAL_VALUE`)
    }

    if (values.customValidations && values.customValidations.length > 50) {
      error.customValidations = props.t(`${tKey}CUSTOM_VALIDATIONS`)
    }
    if (values.solpheoMetadataKey && values.solpheoMetadataKey.length > 50) {
      error.solpheoMetadataKey = props.t(`${tKey}SOLPHEO_CONTAINER_ID`)
    }
    if (values.functionToExecuteInFront && values.functionToExecuteInFront.length > 50) {
      error.functionToExecuteInFront = props.t(`${tKey}FUNCTION_TO_EXECUTE_IN_FRONT`)
    }

    props.languageList && props.languageList.forEach((element) => {
      let valueLangName = values['lang' + element.languageId].name
      let valueLangDesc = values['lang' + element.languageId].description
      let errorLang = {
        name: null,
        description: null
      }
      if (!valueLangName) {
        errorLang.name = props.t(`${tKey}NAME`)
      } else if (valueLangName.length > 50) {
        errorLang.name = props.t(`${tKey}NAME_LENGTH`)
      }
      if (!valueLangDesc) {
        errorLang.description = props.t(`${tKey}DESCRIPTION`)
      } else if (valueLangDesc.length > 50) {
        errorLang.description = props.t(`${tKey}DESCRIPTION_LENGTH`)
      }
      error['lang' + element.languageId] = errorLang
    })

    return Object.keys(error).length > 0 ? error : {}
  }
})(MetadataMasterModal)
